// extracted by mini-css-extract-plugin
module.exports = {"h5button":"hw","h5Button":"hw","button":"hx","block":"hy","btnDefault":"hz","disable":"hA","btnPrimary":"hB"};